import React from 'react'

import {
  CardBody,
  CardRoot,
  CardTitleRow,
} from 'components/filter-card/filter-card.styles'
import {
  CardList,
  ModelPrefix,
  OperatorText,
  Title,
  ValueText,
} from 'features/alerts/components/AlertFilterCards/alert-filter-cards.styles'
import {
  getFilterFieldModel,
  type SelectedFilterOption,
} from 'features/charts-v2/types'
import { buildFilterPreviewEntry } from 'features/dashboards-v2-1/utils'
import type { FilterOption } from 'features/filters/types'

type Props = {
  filters: SelectedFilterOption[]
  filterOptions: readonly FilterOption[]
}

/**
 * The alert's filters as read-only cards: the editor's card shell
 * ("Product > Brand" / operator / value) with every affordance removed. An
 * alert has no parent scope, so none of the dashboard preview's accent bar or
 * superseded styling applies; the label, operator and value text come from
 * `buildFilterPreviewEntry`, the same builder the dashboard tile preview uses.
 */
export const AlertFilterCards: React.FC<Props> = ({
  filters,
  filterOptions,
}) => {
  if (filters.length === 0) return null

  return (
    <CardList>
      {filters.map((filter) => {
        const { label, operator, value } = buildFilterPreviewEntry(
          filter,
          'local',
          false,
          [...filterOptions],
        )
        const model = getFilterFieldModel(filter.field)

        return (
          <CardRoot key={filter.field} $disabled={false}>
            <CardTitleRow $disabled={false}>
              {model && <ModelPrefix>{model} &gt;</ModelPrefix>}
              <Title>{label}</Title>
            </CardTitleRow>
            <CardBody $disabled={false}>
              <OperatorText>{operator}</OperatorText>
              <ValueText>{value}</ValueText>
            </CardBody>
          </CardRoot>
        )
      })}
    </CardList>
  )
}
